module.exports = __webpack_public_path__ + "static/media/quot.ef1e5e5f.png";